import { useNavigate, useParams } from 'react-router-dom'
import { AxiosError } from 'axios'
import { useQueryClient } from '@tanstack/react-query'
import Button from '@/common/components/Button'
import { ShowHeader } from '@/common/components/ShowHeader'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import { useMaintenanceManualEntryProposal } from '../../hooks/useMaintenanceManualEntryProposal'
import ProposalAddProposalButton from '../../components/ProposalAddProposalButton'
import ProposalStatusBanner from '../../components/ProposalStatusBanner'
import ProposalProcessColumn from './components/ProposalProcessColumn'
import ProposalEstablishmentColumn from './components/ProposalEstablishmentColumn'

const MaintenanceProposalsShow = () => {
  const { id } = useParams()

  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const { data: proposal, isPending, error, refetch } = useMaintenanceManualEntryProposal({ proposalId: id })

  const requestStatus = (error as AxiosError | null)?.response?.status
  const forwarding = proposal?.manual_entry?.forwarding
  const equipment = forwarding?.workflow?.equipment

  const handleProposalAccepted = () => {
    queryClient.invalidateQueries({ queryKey: ['maintenanceManualEntryProposals'] })
    refetch()
  }

  return (
    <div className="inner-screen gap-6">
      <ShowHeader
        goBack
        goBackProps={{ fallback: '/maintenance-proposals', searchLastRouteFromFallback: true }}
        title={forwarding?.workflow?.protocol_number ? `Proposta ${forwarding.workflow.protocol_number}` : 'Proposta'}
        subtitle={equipment?.model?.display_name || equipment?.field_for_display_value}
        isLoading={isPending && !proposal}
        buttons={
          proposal?.status === 'awaiting_establishment_response' ? (
            <ProposalAddProposalButton proposal={proposal} onAccepted={handleProposalAccepted} />
          ) : proposal?.status === 'completed' && forwarding?.workflow?.id ? (
            <Button
              operationKlassToCheckPermission="Establishment::Maintenance::Workflows::Show"
              onClick={() => navigate(`/maintenance-workflows/${forwarding.workflow.id}`)}
            >
              Ir para o encaminhamento
            </Button>
          ) : null
        }
      />

      <ErrorMessageWrapper className="flex-1" statusCode={requestStatus ?? 200} refetchFunction={refetch}>
        {proposal && (
          <div className="flex flex-col gap-6 overflow-auto">
            <ProposalStatusBanner proposal={proposal} />

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
              <ProposalProcessColumn proposal={proposal} />
              <ProposalEstablishmentColumn proposal={proposal} onAccepted={handleProposalAccepted} />
            </div>
          </div>
        )}
      </ErrorMessageWrapper>
    </div>
  )
}

export default MaintenanceProposalsShow
